import { Layout, Image, Space, Flex, Divider, Typography } from 'antd';
import { colors, spacing, fontSize } from '../../../theming';
import { useTranslation } from 'react-i18next';
import { useMedia } from '../../../hooks/useMediaQuery';
import { footerMediaLinks } from '../../constants/footerLinks';
import Link from 'antd/es/typography/Link';
import vinLogo from '../../../assets/check-vin-logo.png';
import classes from './footer.module.scss';

const { Footer } = Layout;
const { Text } = Typography;

const GeneralFooter = () => {
    const { t } = useTranslation(['footer']);
    const { isExtraSmallDevice, isSmallDevice } = useMedia();

    return (
        <Footer
            style={{
                backgroundColor: colors.white,
                padding: `${spacing[6]} ${isSmallDevice ? spacing[4] : spacing[2]}`,
                borderBlock: '1px solid #E8E8EB',
            }}
            className={classes['footer']}
        >
            <Flex
                vertical
                justify="center"
                align="center"
                style={{ width: '100%', maxWidth: '1440px', margin: '0 auto' }}
                gap={spacing[5]}
            >
                <Flex
                    vertical={isExtraSmallDevice}
                    gap={isExtraSmallDevice ? spacing[7] : 0}
                    justify="space-between"
                    align="center"
                    style={{ width: '100%' }}
                >
                    <Space xs={24} sm={12}>
                        <Link href={'/'}>
                            <Image
                                preview={false}
                                src={vinLogo}
                                alt="Check vin.ai logo"
                                width={100}
                                style={{ cursor: 'pointer' }}
                            />
                        </Link>
                    </Space>

                    {/* <Flex vertical={isExtraSmallDevice} gap={spacing[5]} justify="space-between" align="center">
                        <a disabled={true} href={''}>
                            {t('footer.report')}
                        </a>
                        <a disabled={true} href={''}>
                            {t('footer.weAreChecking')}
                        </a>
                        <a disabled={true} href={''}>
                            {t('footer.reviews')}
                        </a>
                        <a disabled={true} href={''}>
                            {t('footer.faq')}
                        </a>
                    </Flex> */}
                    {/*
                    <Space xs={24} sm={12} md={4}>
                        <Flex gap={spacing[4]} className={classes['footer__socials']}>
                            {footerMediaLinks.map(link => (
                                <Link href={link.link} key={link.link}>
                                    <Image
                                        width={isExtraSmallDevice ? 32 : 24}
                                        preview={false}
                                        src={link.image}
                                        alt={`${link.title} logo`}
                                    />
                                </Link>
                            ))}
                        </Flex>
                    </Space> */}
                </Flex>

                <Divider />

                <Flex
                    vertical={isExtraSmallDevice}
                    gap={isExtraSmallDevice ? spacing[4] : 0}
                    justify="space-between"
                    align="center"
                    style={{ width: '100%' }}
                >
                    <Text
                        style={{
                            cursor: 'pointer',
                            fontSize: isExtraSmallDevice ? 13 : fontSize.xs,
                            order: isExtraSmallDevice ? 2 : 0,
                        }}
                    >
                        {t('footer.copyright', { year: new Date().getFullYear() })}
                    </Text>

                    {/* <Flex gap={spacing[4]}>
                        <Link disabled={true} href={'/'}>
                            {t('footer.privacyPolicy')}
                        </Link>
                        <Link disabled={true} href={'/'}>
                            {t('footer.termsOfService')}
                        </Link>
                        <Link disabled={true} href={'/'}>
                            {t('footer.cookiesSettings')}
                        </Link>
                    </Flex> */}
                </Flex>
            </Flex>
        </Footer>
    );
};

export default GeneralFooter;
